/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Breadcrumbs_No_Permission_ToastInputs */



/**
* | output |
* | --- |
* | "You don't have permission to access this folder" |
*
* @param {Explorer_Breadcrumbs_No_Permission_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_breadcrumbs_no_permission_toast = /** @type {((inputs?: Explorer_Breadcrumbs_No_Permission_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Breadcrumbs_No_Permission_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous n'avez pas la permission d'acceder a ce dossier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie haben keine Berechtigung, auf diesen Ordner zuzugreifen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non hai l'autorizzazione per accedere a questa cartella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("У вас нет разрешения на доступ к этой папке.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No tienes permiso para acceder a esta carpeta")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您没有权限访问此文件夹")
	if (locale === "ja") return /** @type {LocalizedString} */ ("このフォルダにアクセスする権限がありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपको इस फ़ोल्डर तक पहुँचने की अनुमति नहीं है")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Você não tem permissão para acessar esta pasta.")
	return /** @type {LocalizedString} */ ("You don't have permission to access this folder")
});